// extracted by mini-css-extract-plugin
export default {"container":"About_container__WAkph","aboutContainer":"About_aboutContainer__HuyZJ"};